module.exports = __webpack_public_path__ + "img/other-icon.65162e62.svg";